// extracted by mini-css-extract-plugin
module.exports = {"SocialMediaButton":"SocialMediaButton_SocialMediaButton__2PLOb"};